import { Customer } from "@/api/customer";

const getCookie = (cname) => {
  let name = cname + "=";
  // let decodedCookie = decodeURIComponent(document.cookie);
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const state = {
  display: false,
  dir: "ltr",
  config: {
    ASUSTicket: getCookie("aticket"),
    countryId: "TW",
    platform: "",
    position: "left",
    roomId: "", //若有 , 直接前往該 room
  },
  lastRoomInfo: {
    lastClientChatRoomInfo: null,
    lastChatBotRoomInfo: null,
  },
  lastClientChatRoomInfo: null,
  lastChatBotRoomInfo: null,
};

const actions = {
  toggleDisplay({ state, commit }) {
    commit("setDisplay", !state.display);
  },
  async checkLastRoomInfo({ state, commit, dispatch }) {
    let result = {
      lastClientChatRoomInfo: null,
      lastChatBotRoomInfo: null,
    };
    if (state.config.ASUSTicket) {
      try {
        const res = await Customer.CheckIsCrossSite({
          ASUSTicket: state.config.ASUSTicket,
          DetectedCountry: state.config.countryId,
          AsusWebSiteCountry: state.config.countryId,
        });
        commit("setLastRoomInfo", res.data);
        // 1. Chat Room 優先
        if (res.data.lastClientChatRoomInfo) {
          result.lastClientChatRoomInfo = res.data.lastClientChatRoomInfo;
          dispatch("GetClientChatDetail", res.data.lastClientChatRoomInfo);
        }
        // 2. Bot Room
        if (res.data.lastChatBotRoomInfo) {
          result.lastChatBotRoomInfo = res.data.lastChatBotRoomInfo;
          dispatch("getBotDeatil", res.data.lastChatBotRoomInfo);
        }
      } catch (error) {
        console.log("catch", error);
      }
    } else {
      console.log("no aticket!");
    }
  },
  async GetClientChatDetail({ state, commit }, payload) {
    try {
      const { clientChatRoomId, sessionId } = payload;
      const res = await Customer.GetClientChatDetail({
        clientChatRoomId: clientChatRoomId.toString(),
        sessionId: sessionId,
      });
      // console.log("取得上一個 Chat room", res);
      commit("setLastClientChatRoomInfo", res.data);
    } catch (error) {
      console.log("catch", error);
    }
  },
  async getBotDeatil({ state, commit }, payload) {
    try {
      const { chatBotRoomId, sessionId } = payload;
      const res = await Customer.GetMessageList({
        chatBotRoomId: chatBotRoomId.toString(),
        sessionId: sessionId,
      });
      // console.log("取得上一個 Bot room", res);
      commit("setLastBotRoomInfo", res.data);
    } catch (error) {
      console.log("catch", error);
    }
  },
};

const mutations = {
  setDisplay(state, payload) {
    state.display = payload;
  },
  setConfig(state, payload) {
    Object.assign(state.config, payload);
  },
  cleanRoomId(state) {
    state.config.roomId = "";
  },
  setDir(state, payload) {
    state.dir = payload;
  },
  setLastRoomInfo(state, payload) {
    state.lastRoomInfo.lastClientChatRoomInfo =
      payload.lastClientChatRoomInfo || null;
    state.lastRoomInfo.lastChatBotRoomInfo =
      payload.lastChatBotRoomInfo || null;
  },
  setLastClientChatRoomInfo(state, payload) {
    state.lastClientChatRoomInfo = payload;
  },
  setLastBotRoomInfo(state, payload) {
    state.lastChatBotRoomInfo = payload;
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
